import React from 'react';
import VehicleBranch from './vehicleBranch';
import { Vehicle } from '@sharedTypes/Vehicle';

interface BranchFooterProps {
  branchInfo?: Vehicle['branch'];
  clickAndCollectDetails?: Vehicle['clickAndCollectDetails'];
  vehicleMovable?: boolean;
}

const BranchFooter = ({
  branchInfo,
  clickAndCollectDetails,
  vehicleMovable,
}: BranchFooterProps) => {
  return (
    <div className="ch-lh--base ch-mb--3 ch-mh--2">
      <div
        className={`ac-result__branches ${
          vehicleMovable ? 'ac-result__branches--movable' : ''
        }`}
      >
        {branchInfo && (
          <VehicleBranch {...branchInfo} vehicleMovable={vehicleMovable} />
        )}
        {vehicleMovable && clickAndCollectDetails && (
          <VehicleBranch
            {...clickAndCollectDetails}
            prefix="Collect in 7 days from"
            vehicleMovable
          />
        )}
      </div>
    </div>
  );
};

export default React.memo(BranchFooter);
